var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrazy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 457,
    viewBox: "0 0 257 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.214 0.801029C254.45 1.48923 255.421 2.57167 255.97 3.87569C256.52 5.17972 256.616 6.63019 256.245 7.99572L127.538 226.492H188.912C190.146 226.492 191.354 226.853 192.386 227.53C193.418 228.207 194.23 229.171 194.721 230.303C195.213 231.435 195.363 232.686 195.153 233.903C194.943 235.119 194.382 236.247 193.54 237.149L10.968 454.282C10.0023 455.319 8.7167 456.002 7.31687 456.222C5.91705 456.443 4.48386 456.187 3.24654 455.496C2.00922 454.805 1.03926 453.72 0.491789 452.413C-0.0556832 451.106 -0.149037 449.653 0.226664 448.287L110.953 264.493H49.5784C48.3441 264.492 47.1368 264.132 46.1048 263.455C45.0728 262.778 44.2611 261.814 43.7695 260.682C43.2779 259.55 43.1278 258.299 43.3376 257.082C43.5475 255.866 44.1082 254.738 44.9508 253.836L245.504 2.00859C246.47 0.975374 247.754 0.295141 249.151 0.0762935C250.548 -0.142554 251.978 0.112576 253.214 0.801029Z",
    fill: "#E6261F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrazy);
export default __webpack_public_path__ + "static/media/crazy.f48ca5c26d0b51c5bd8847aa56319ad8.svg";
export { ForwardRef as ReactComponent };